export enum NotificationPermissionType {
  orderNPACFailedRequests = "TN SV Request Failed",
  newPortOutRequestReceived = "New TN Port-Out SV",
  orderNPACSvUpdated = "TN SV Updates",
  general = "General"
}
